import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Service } from '../models/entities/service';
import { SettlementDataResponse } from '../models/dtos/settlement-data-response';
import { SettlementValidationRquest } from '../models/dtos/settlement-validation-request';
import { BankNote } from 'src/app/assabil-kernel/models/entities/control-tables/bank-note';


@Injectable({
    providedIn: 'root'
})
export class SettlementService {

    constructor(
        private networkService  : LeanNetworkService,
        public userService      : UserService) {
    }

    
    //------------------------------------------------------------------------------------
    // Services To Settle Get
    //------------------------------------------------------------------------------------
    settlementDataGet(roleCode : string) : Promise<SettlementDataResponse>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code = roleCode;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/settlement/settlementDataGet', request).then(result => {
                return resolve(result);
            }, error => {
                reject(error);
            });
        });
    }


    //------------------------------------------------------------------------------------
    // validate Settlement
    //------------------------------------------------------------------------------------
    settlementValidate(roleCode : string, services : Service[], bankNotes : BankNote[], cashAmount : number, nonCashAmount : number) : Promise<string>{
    
        let request: SettlementValidationRquest = new SettlementValidationRquest(this.userService.userInfo);
        request.code            = roleCode;
        request.services        = services;
        request.bankNotes       = bankNotes;

        request.cashAmount      = cashAmount;
        request.nonCashAmount    = nonCashAmount;


        return new Promise((resolve, reject) => {
            this.networkService.post('sales/settlement/settlementValidate', request).then(result => {
                return resolve(result.code);
            }, error => {
                reject(error);
            });
        });
    }

    //------------------------------------------------------------------------------------
    // validate Settlement
    //------------------------------------------------------------------------------------
    settlementPrint(code : string) : Promise<string>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/settlement/settlementPrint', request).then(result => {
                return resolve(result.pdf);
            }, error => {
                reject(error);
            });
        });
    }

}
